import { AddCircleOutline } from '@mui/icons-material';
import { IconButton, Tooltip, Typography } from '@mui/material';
import { memo } from 'react';

interface ListHeaderProps {
  title: string;
  addBtnLabel: string;
  addBtnAriaLabel: string;
  canAdd: boolean;
  onAddBtnClick: () => void;
  authorizationTooltipContent?: React.ReactElement;
}

const ListHeaderComponent = ({
  title,
  addBtnLabel,
  onAddBtnClick,
  addBtnAriaLabel,
  canAdd,
  authorizationTooltipContent,
}: ListHeaderProps): React.ReactElement => {
  return (
    <div className="pmi-pt-4 pmi-pb-3 pmi-d-flex pmi-align-items-center pmi-justify-content-between">
      <Typography
        color="secondary.main"
        style={{
          fontSize: '26px',
        }}
      >
        {title}
      </Typography>
      <Tooltip
        arrow
        title={canAdd ? '' : "Non si ha l'autorizzazione per accedere a questa funzionalità"}
      >
        {authorizationTooltipContent || (
          <span>
            <IconButton
              onClick={onAddBtnClick}
              aria-label={addBtnAriaLabel}
              aria-haspopup="true"
              disabled={!canAdd}
            >
              <AddCircleOutline />
            </IconButton>
            <Typography color="secondary" display="inline-block">
              {addBtnLabel}
            </Typography>
          </span>
        )}
      </Tooltip>
    </div>
  );
};

ListHeaderComponent.displayName = 'ListHeader';

const ListHeader = memo(ListHeaderComponent);

export default ListHeader as typeof ListHeaderComponent;
